import { createRouter, createWebHistory } from 'vue-router'

import AppLayout from '@/layout/AppLayout.vue'
import { useUserStore } from '@/stores/userStore'
import LegalView from '@/views/legal/LegalView.vue'
import InfoView from '@/views/info/InfoView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/auth/LoginView.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/',
      component: AppLayout,
      name: 'home',
      redirect: { name: 'list_identification_tasks' },
      children: [
        {
          path: 'annotations',
          name: 'list_annotations',
          component: () => import('@/views/annotations/ListView.vue'),
        },
        {
          path: 'identification_tasks',
          children: [
            {
              path: '',
              name: 'list_identification_tasks',
              component: () => import('@/views/identification_task/ListView.vue'),
            },
            {
              path: ':observationUuid',
              children: [
                {
                  path: '',
                  name: 'identification_task',
                  component: () => import('@/views/identification_task/DetailView.vue'),
                },
                {
                  path: 'annotations/new',
                  name: 'annotate_identification_task',
                  component: () => import('@/views/annotations/CreateView.vue'),
                  props: true,
                },
              ],
            },
          ],
        },
        {
          path: 'messages',
          children: [
            {
              path: '',
              name: 'list_messages',
              component: () => import('@/views/messages/ListView.vue'),
            },
            {
              path: ':messageId',
              name: 'message_detail',
              component: () => import('@/views/messages/DetailView.vue'),
              props: (route) => ({
                messageId: Number(route.params.messageId),
              }),
            },
          ],
        },
      ],
    },
    // ------------------------
    // Legal Pages
    // ------------------------
    {
      path: '/:lang?/legal/:doc',
      name: 'Legal',
      component: LegalView,
      props: (route) => ({ lang: route.params.lang, doc: route.params.doc }),
      meta: {
        requiresAuth: false,
      },
    },

    // ------------------------
    // Info Pages
    // ------------------------
    {
      path: '/:lang?/info/:doc',
      name: 'Info',
      component: InfoView,
      props: (route) => ({ lang: route.params.lang, doc: route.params.doc }),
      meta: {
        requiresAuth: false,
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  const authRequired = to.meta.requiresAuth !== false
  // Check if the user is authenticated
  const userStore = useUserStore()
  if (authRequired && !userStore.user) {
    // Redirect to the login page if not authenticated
    next({
      name: 'login',
      query: {
        next: to.fullPath,
      },
    })
  } else {
    // Proceed to the requested route
    next()
  }
})

export default router
